import axios, { AxiosResponse } from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { store } from 'src/modules/shared/store';
import { TrajectoryLockStatus } from 'src/config/api/models/Trajectory';
import apiRoutesV2 from 'src/config/api/routes';

export const lockTrajectory = createAsyncThunk('trajectory/lock', async (trajectoryId: string) => {
  const { jwt, user } = store.getState().auth;

  const response: AxiosResponse<{ data: TrajectoryLockStatus }> = await axios({
    url: apiRoutesV2.lock(trajectoryId),
    method: 'POST',
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  });

  return { lockStatus: response.data.data, user };
});

export const checkTrajectoryHasLock = createAsyncThunk(
  'trajectory/checkHasLock',
  async (trajectoryId: string) => {
    const { jwt, user } = store.getState().auth;

    const response: AxiosResponse<{ data: TrajectoryLockStatus }> = await axios({
      url: apiRoutesV2.lockStatus(trajectoryId),
      method: 'GET',
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    });

    return { lockStatus: response.data.data, user };
  }
);

export const unlockTrajectory = createAsyncThunk(
  'trajectory/unlock',
  async (trajectoryId: string) => {
    const { jwt, user } = store.getState().auth;

    const response: AxiosResponse<{ data: TrajectoryLockStatus }> = await axios({
      url: apiRoutesV2.unlock(trajectoryId),
      method: 'POST',
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    });

    return { lockStatus: response.data.data, user };
  }
);
